import { useContext, useState, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { AgentSurveyQuery } from 'interfaceAdapter/queries/AgentSurvey';
import { SurveyForAgentRepository } from 'interfaceAdapter/repositories/SurveyForAgent';
import { useParams } from 'react-router-dom';
import { ISurvey } from 'domain/entities/Survey/Survey';
import { useForm } from 'react-hook-form';
import { useLoading } from 'application/contexts/useLoading';

export const useSurveyForm = () => {
    const diContainer = useContext(diContainerContext);
    const agentSurveyQuery = diContainer.resolve(AgentSurveyQuery);
    const surveyForAgent = diContainer.resolve(SurveyForAgentRepository);
    const { loading, setLoading } = useLoading();
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [survey, setSurvey] = useState<ISurvey | null>(null);
    const params = useParams();
    const matchId = Number(params.matchId);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm();

    useEffect(() => {
        const fetchSurveyDataForAgent = async () => {
            if (!matchId) {
                return;
            }

            try {
                setLoading(true);
                const data = await agentSurveyQuery.fetch(matchId);

                if (!data) {
                    throw new Error('アンケート情報の取得に失敗しました');
                }

                setSurvey(data as ISurvey);
            } finally {
                setLoading(false);
            }
        };

        fetchSurveyDataForAgent();
    }, []);

    const onSubmit = handleSubmit(async (data) => {
        try {
            setLoading(true);
            const answers = survey?.question_data.map((question) => {
                // 空文字の場合はnullに変換する必要がある
                return data[question.id] || data[question.id] === 0 ? data[question.id] : null;
            });
            answers && (await surveyForAgent.answer(matchId, answers));
            setShowSnackbar(true);
            setTimeout(() => {
                window.location.replace('/agent/dashboard');
            }, 1500);
        } finally {
            setLoading(false);
        }
    });

    return {
        survey,
        loading,
        showSnackbar,
        errors,
        setShowSnackbar,
        onSubmit,
        register,
        setValue,
    };
};
